import { SortDirection } from '@mui/material';
import { SortCriteria } from 'dashboard409a/common/constants/analyst-dashboard';
import theme from 'theme';
import { ModelsTableHeadColumn } from '../../ModelsTable/ModelsTable.types';

const createSortHandler = (onRequestSort: (event: React.MouseEvent<unknown>, property: string, addToSort?: boolean) => void) => (property: string) => (event: React.MouseEvent<unknown>) => {
  const addToSort = event.shiftKey;
  onRequestSort(event, property, addToSort);
};

const orderHandler = (sortArg: string, sortDefault: SortDirection, orderBy: string, order: SortDirection, sortCriteria?: SortCriteria[]) => {
  // If we have sortCriteria, check if this column is in any of them
  if (sortCriteria && sortCriteria.length > 0) {
    const criteria = sortCriteria.find(c => c.property === sortArg);
    if (criteria) {
      return criteria.direction as SortDirection;
    }
  }
  // Fallback to single sort behavior
  if (orderBy === sortArg) {
    return order;
  }
  return sortDefault;
};

const isActive = (headCell: ModelsTableHeadColumn, orderBy: string, sortCriteria?: SortCriteria[]) => {
  // If we have sortCriteria, check if this column is in any of them
  if (sortCriteria && sortCriteria.length > 0) {
    return sortCriteria.some(c => c.property === headCell.id);
  }
  // Fallback to single sort behavior
  return orderBy === headCell.id;
};

const getSortIconStyle = (headCell: ModelsTableHeadColumn, orderBy: string, sortCriteria?: SortCriteria[]) => ({
  icon: {
    width: '10%',
    ...(isActive(headCell, orderBy, sortCriteria) && { color: `${theme.palette.primary.dark} !important`, opacity: 1 }),
    ...(!isActive(headCell, orderBy, sortCriteria) && { opacity: 0.2 }),
  },
});

/**
 * Calculates table height accounting for zoom level
 * @param zoomLevel - The current zoom level (typically from useZoom hook)
 * @param offset - The offset in pixels to subtract from the viewport height (default: 200)
 * @returns A CSS height string (e.g., "800px" or "calc(100vh - 200px)")
 */
const calculateTableHeight = (zoomLevel: number, offset: number = 200): string => {
  if (globalThis.window) {
    const viewportHeight = globalThis.window.innerHeight;
    const adjustedHeight = viewportHeight / zoomLevel;
    return `${adjustedHeight - offset}px`;
  }
  return `calc(100vh - ${offset}px)`;
};

export {
  createSortHandler,
  orderHandler,
  isActive,
  getSortIconStyle,
  calculateTableHeight,
}